export type EscapeAction = 'closePicker' | 'clearRemoval' | 'clearTarget' | 'cancelEdit' | null

/**
 * Escape peels one layer of transient state per press instead of clearing everything
 * at once: visit picker first, then pending removal, then add target, then the
 * mid-route edit session itself.
 */
export function resolveEscapeAction(state: {
  hasActivePicker: boolean
  hasPendingRemoval: boolean
  hasAddTarget: boolean
  hasEditState: boolean
}): EscapeAction {
  if (state.hasActivePicker) return 'closePicker'
  if (state.hasPendingRemoval) return 'clearRemoval'
  if (state.hasAddTarget) return 'clearTarget'
  if (state.hasEditState) return 'cancelEdit'
  return null
}
